import { call, put, takeEvery } from "redux-saga/effects";

import {
  GET_PAYFAC_COMMISSIONS_BY_PRICING_TABLE_GUID_AND_MERCHANT_GUID,
  INSERT_MERCHANT_COMMISSIONS,
  UPDATE_MERCHANT_COMMISSIONS,
  } from "./actionTypes"

import {
getPayFacCommissionsByPricingTableGuidAndMerchantGuidSuccess,
insertMerchantCommissionsSuccess,
updateMerchantCommissionsSuccess,
merchantCommissionListApiError
} from "./actions"

import {
  getPayFacCommissionsByPricingTableGuidAndMerchantGuid,
  insertMerchantcommissions,
  updateMerchantcommissions,
} from "../../helpers/backend_helper/backend_helper"

import { toast,Zoom } from "react-toastify";
import i18n from 'i18n';

function* onGetPayFacCommissionsByPricingTableGuidAndMerchantGuid({ payload: record }) {
  try {
    const response = yield call(getPayFacCommissionsByPricingTableGuidAndMerchantGuid, record)
    yield put(getPayFacCommissionsByPricingTableGuidAndMerchantGuidSuccess(response))
  } catch (error) {
    yield put(merchantCommissionListApiError(error))
  }
}

function* onInsertMerchantCommissions({ payload: record }) {
  try {
    const response = yield call(insertMerchantcommissions, record)
    yield put(insertMerchantCommissionsSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(merchantCommissionListApiError(error))
  }
}

function* onUpdateMerchantCommissions({ payload: record }) {
  try {
    const response = yield call(updateMerchantcommissions, record)
    yield put(updateMerchantCommissionsSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(merchantCommissionListApiError(error))
  }
}

function* merchantCommissionListSaga() {

    yield takeEvery(GET_PAYFAC_COMMISSIONS_BY_PRICING_TABLE_GUID_AND_MERCHANT_GUID,onGetPayFacCommissionsByPricingTableGuidAndMerchantGuid)
    yield takeEvery(INSERT_MERCHANT_COMMISSIONS,onInsertMerchantCommissions)
    yield takeEvery(UPDATE_MERCHANT_COMMISSIONS,onUpdateMerchantCommissions)
}

export default merchantCommissionListSaga
